import React from 'react'

import "../styles/feedback.css"
import axios from 'axios';

import { apiUrl } from '..';

import { useEffect } from 'react';

import { useAlert } from 'react-alert';

const FeedBack = () => {
    const alert = useAlert();

    useEffect(() => {
        const feedback = document.querySelector('textarea')

        feedback.innerHTML = "Response relevance (1-10): \nWhat I feel could be added/fixed:\n  \nAny other comments / suggestions:"
        
    }, [])

    const sendFeedback = () => {
        console.log("feedback sent")
        const feedback = document.querySelector('textarea').value
        axios({
            method: 'post',
            url: `${apiUrl}/feedback`,
            data: { feedback }
        }).then((response) => {
            alert.success("Feedback sent successfully")
            console.log(response)
        }).catch((error) => {
            alert.error("An error occurred while trying to submit your feedback.")
            console.log(error)
        })
    }
    return (
        <>
        <div className='header flex text-center' id='FeedbackHeader'>
            <h2 data-aos="fade-down" data-aos-anchor="#FeedbackHeader" data-aos-delay="100">Feedback</h2>
            <p data-aos="fade-down" data-aos-anchor="#FeedbackHeader" data-aos-delay="200">Please provide your view on how we can inprove</p>
        </div>
        <div id="Feedback">
            <textarea placeholder="Enter your feedback here" data-aos="fade-down" data-aos-anchor="#FeedbackHeader" data-aos-delay="300"></textarea>
            <button onClick={() => sendFeedback()}  data-aos="zoom-in" data-aos-anchor="#FeedbackHeader" data-aos-delay="400">Submit</button>
        </div>
        </>
    )
}

export default FeedBack